
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/day-substitution/jst/DaySubstitution';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n      <option value=\"";
  if (helper = helpers.index) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.index); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n    ";
  return buffer;
  }

  buffer += "<label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.move_from", "Move from", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.move_from", "Move from", options)))
    + "</strong></label>\n<div class=\"controls\">\n  <select class=\"currentDay span3\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.move_from_select_title", "Move from day of the week", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.move_from_select_title", "Move from day of the week", options)))
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.move_from_select_label", "Move from day of the week", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.move_from_select_label", "Move from day of the week", options)))
    + "\"> \n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.weekdays), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </select>\n  "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.to_happen_on", "to", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.to_happen_on", "to", options)))
    + "\n  <select class=\"subDay span3\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.move_to_select_title", "Move to day of the week", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.move_to_select_title", "Move to day of the week", options)))
    + "\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.move_to_select_label", "Move to day of the week", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.move_to_select_label", "Move to day of the week", options)))
    + "\">\n    ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.weekdays), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </select>\n  <a href=\"#\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.remove_day_substitution_link_label", "Remove day substitution", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.remove_day_substitution_link_label", "Remove day substitution", options)))
    + "\" title=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("content_migrations.subviews.day_substitution")
  },data:data},helper ? helper.call(depth0, "content_migrations.subviews.day_substitution.remove_day_substitution_link", "Remove day substitution", options) : helperMissing.call(depth0, "t", "content_migrations.subviews.day_substitution.remove_day_substitution_link", "Remove day substitution", options)))
    + "\"><i class=\"icon-end plain\"></i></a>\n</div>\n<br />\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  